var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Body } from 'syf-component-library/ui/typography';
import { Inset } from 'syf-component-library/ui/spacing';
import { shallowEqual, useSelector } from 'react-redux';
import QuestionHeader from '../../../ui/atoms/Header';
import getCurrentQuestionAnswer from '../../../helpers/getCurrentQuestionAnswer';
import { FieldType } from '../../../redux/questionnaire/typings';
import { t } from '../../../strings/i18n/i18n';
import parseCalendarDates from '../../../helpers/parseCalendarDates';
import TextField from '../TextField';
import AdditionalCalendar from './subcomponents/AdditionalCalendar';
var PLACEHOLDER_MAX_LENGTH = 31;
var AUXILIARY_PLACEHOLDER = 'Enter Discount Details';
var replacementQuestionIds = ['SQ73', 'SQ118'];
var AdditionalContent = function (_a) {
    var _b;
    var answerMetadata = _a.answerMetadata, textfieldRef = _a.textfieldRef;
    var _c = useSelector(function (state) { return state; }, shallowEqual), userAnswers = _c.userAnswers, currentQuestion = _c.questionnaire.currentQuestion;
    var _d = answerMetadata[0], inputType = _d.type, placeHolder = _d.placeHolder, fieldType = _d.fieldType, metadataStartDate = _d.startDate, metadataEndDate = _d.endDate, metadataExcludedDates = _d.excludedDates, isEligibleForPartialAmount = _d.isEligibleForPartialAmount;
    var currentQuestionAnswer = getCurrentQuestionAnswer({
        userAnswers: userAnswers,
        currentQuestion: currentQuestion
    });
    var questionType = (_b = currentQuestion.answers[0]) === null || _b === void 0 ? void 0 : _b.fieldType;
    var shouldReplacePlaceholder = placeHolder.length > PLACEHOLDER_MAX_LENGTH &&
        replacementQuestionIds.includes(currentQuestion.id);
    if (fieldType === FieldType.Text) {
        return (_jsx(Inset, __assign({ horizontal: "xlarge" }, { children: _jsx(Body, { children: placeHolder }) })));
    }
    // TODO: Fix this ridiculousness and only enfore validation from the API
    if (fieldType === FieldType.Date) {
        var _e = parseCalendarDates({
            startDate: metadataStartDate,
            endDate: metadataEndDate,
            excludedDates: metadataExcludedDates
        }), startDate = _e.startDate, endDate = _e.endDate, excludedDates = _e.excludedDates;
        return (_jsxs(_Fragment, { children: [_jsx(Inset, __assign({ horizontal: "xsmall" }, { children: _jsx(QuestionHeader, { content: placeHolder }) })), _jsx(AdditionalCalendar, { startDate: startDate, endDate: endDate, excludedDates: excludedDates, currentQuestionAnswer: currentQuestionAnswer })] }));
    }
    if (questionType === FieldType.Date) {
        return (_jsxs(_Fragment, { children: [_jsx(Inset, __assign({ horizontal: "xsmall" }, { children: _jsx(QuestionHeader, { content: placeHolder }) })), _jsx(TextField, { dataCy: "calendar-additional-textbox", isAdditionalContent: true, additionalInputType: inputType, additionalPlaceHolder: "".concat(t('additionalContent.placeholder')), isEligibleForPartialAmount: isEligibleForPartialAmount, textfieldRef: textfieldRef })] }));
    }
    return (_jsxs(Inset, __assign({ horizontal: "base" }, { children: [shouldReplacePlaceholder && _jsx(Body, { children: placeHolder }), _jsx(TextField, { textfieldRef: textfieldRef, isAdditionalContent: true, additionalInputType: inputType, additionalPlaceHolder: shouldReplacePlaceholder ? AUXILIARY_PLACEHOLDER : placeHolder, isEligibleForPartialAmount: isEligibleForPartialAmount })] })));
};
export default AdditionalContent;
//# sourceMappingURL=index.js.map